import React from "react";
import { ReCaptchaInstance } from "recaptcha-v3";

export const CaptchaContext = React.createContext<
  ReCaptchaInstance | undefined
>(undefined);
